/**
 * A custom error class for errors that are caused by user actions.
 *
 * @example
 * throw new CartUserError('Product A is not available', { productId: 123 })
 */
export class CartUserError extends Error {
    constructor(
        message: string,
        public details: { description: string; [k: string]: unknown },
    ) {
        super(message);

        Object.defineProperty(this, "name", {
            value: new.target.name,
            enumerable: false,
            configurable: true,
        });

        Object.setPrototypeOf(this, new.target.prototype);
    }
}
